import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVersionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4707 3C10.4707 2.44772 10.9184 2 11.4707 2L21.0001 2C21.5524 2 22.0001 2.44772 22.0001 3V12.5294C22.0001 13.0817 21.5524 13.5294 21.0001 13.5294L11.4707 13.5294C10.9184 13.5294 10.4707 13.0817 10.4707 12.5294L10.4707 3ZM12.4707 4L12.4707 11.5294L20.0001 11.5294V4L12.4707 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.23438 15.7647L8.23438 7.23529H6.23438L6.23438 16.7647C6.23438 17.317 6.68209 17.7647 7.23438 17.7647H16.7638V15.7647L8.23438 15.7647Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 20L4 11.4706H2L2 21C2 21.5523 2.44772 22 3 22H12.5294V20H4Z",
			fill: "currentColor"
		})
	]
});
export default SvgVersionIcon;
